import React, { useState, useContext, useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Field } from 'formik';
import { Grid, TextField, makeStyles } from '@material-ui/core';
import { FormServiceContext } from 'app/utils/contexts';
import { REASONS_CHANGE_EMAIL } from 'app/utils/forms/payloadsStruture';
import { RadioButton, RadioButtonGroup } from 'app/components/FormElements';
import Identification from '../Identification';
import helpers from 'app/utils/helpers';
import styles from './styles';

const useStyles = makeStyles(styles);

export default function ChangeEmailForm(props) {
    const classes = useStyles();
    const { intl, values, errors, touched, handleBlur } = props;
    const { isInternalForm, user, canEdit } = useContext(FormServiceContext);
    const registrationUserInfo = useSelector((state) => state.auth.registrationInfo);

    const isGuest = useMemo(() => {
        if (isInternalForm) return !Boolean(values.cdEmpresa) && !Boolean(values.cdUsuario);
        return Object.keys(registrationUserInfo).length === 0;
    }, [values.cdEmpresa, values.cdUsuario, registrationUserInfo, isInternalForm]);

    useEffect(() => {
        if (!values?.boVisitante) {
            values.boVisitante = isGuest;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isGuest]);

    const username = useMemo(() => (user?.nmUsuario ? user.nmUsuario : ''), [user]);

    const [deCpfCnpj, setDeCpfCnpj] = useState(() => {
        if (values.deCpfCnpj && values.deCpfCnpj !== '') return helpers.formatarDocumento(values.deCpfCnpj);
        return '';
    });
    const [emailError, setEmailError] = useState(null);

    function validateDocument(value) {
        let error;
        if (!helpers.validateCpfCnpj(value)) {
            error = 'Documento inválido';
        }
        return error;
    }

    const handleChangeDocument = (e, values) => {
        const number = helpers.formatarDocumento(e.target.value);
        setDeCpfCnpj(number);
        values.deCpfCnpj = number;
    };

    const handleEmailBlur = (e) => {
        const value = e.target.value;
        if (values?.deEmail && value === values.deEmail) {
            setEmailError(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.EMAIL_IGUAL_SOLICITADO' }));
        } else {
            setEmailError(null);
        }
        if (handleBlur) handleBlur(e);
    };

    return (
        <>
            {isInternalForm && (
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            name="usuarioResponsavel"
                            label="Usuário Responsável"
                            margin="dense"
                            fullWidth
                            disabled
                            value={username}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>
                </Grid>
            )}
            <Grid container spacing={3}>
                <Identification {...props} isGuest={isGuest} />

                {isGuest && (
                    <Grid item xs={12} sm={4}>
                        {canEdit ? (
                            <Field
                                name="deCpfCnpj"
                                label="CPF/CNPJ*"
                                variant="filled"
                                margin="dense"
                                value={deCpfCnpj}
                                fullWidth
                                error={!!errors.deCpfCnpj}
                                helperText={errors.deCpfCnpj && touched.deCpfCnpj ? errors.deCpfCnpj : ''}
                                onChange={(e) => handleChangeDocument(e, values)}
                                as={TextField}
                                inputProps={{
                                    maxLength: 18,
                                }}
                                validate={validateDocument}
                            />
                        ) : (
                            <TextField
                                value={helpers.formatarDocumento(values?.deCpfCnpj)}
                                label={'CPF/CNPJ*'}
                                variant="filled"
                                margin="dense"
                                disabled
                                fullWidth
                            />
                        )}
                    </Grid>
                )}
                <Grid item xs={12} sm={isGuest ? 8 : 12}>
                    <Field
                        name="deNewEmail"
                        label={'Novo e-mail*'}
                        variant="filled"
                        margin="dense"
                        disabled={!canEdit}
                        fullWidth
                        onBlur={handleEmailBlur}
                        error={emailError ?? (!!errors.deNewEmail && touched.deNewEmail)}
                        helperText={
                            emailError ? emailError : errors.deNewEmail && touched.deNewEmail ? errors.deNewEmail : ''
                        }
                        as={TextField}
                        inputProps={{
                            maxLength: 90,
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <RadioButtonGroup
                        id="deMotivo"
                        label="Motivo para a alteração do e-mail"
                        value={values?.deMotivo || REASONS_CHANGE_EMAIL[0].value}
                        error={errors.deMotivo}
                        touched={touched.deMotivo}
                        className={classes.radioGroup}>
                        {REASONS_CHANGE_EMAIL.map((reason) => {
                            return (
                                <Field
                                    key={reason.value}
                                    id={reason.value}
                                    component={RadioButton}
                                    name="deMotivo"
                                    label={reason.label}
                                    disabled={!canEdit}
                                />
                            );
                        })}
                    </RadioButtonGroup>
                </Grid>
                <Grid item xs={12}>
                    <Field
                        name="deObservacao"
                        label="Observações"
                        variant="filled"
                        margin="dense"
                        disabled={!canEdit}
                        multiline
                        minRows={4}
                        fullWidth
                        error={!!errors.deObservacao}
                        helperText={errors.deObservacao ? errors.deObservacao : ''}
                        as={TextField}
                        inputProps={{
                            maxLength: 4900,
                        }}
                    />
                </Grid>
            </Grid>
        </>
    );
}
